import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerUploadResponse } from "../../types/CustomerUpload";

interface CustomerUploadState {
    status: "idle" | "loading" | "success" | "error";
    data: CustomerUploadResponse | null;
    error: string | null;
}

const initialState: CustomerUploadState = {
    status: "idle",
    data: null,
    error: null,
};

const customerUploadSlice = createSlice({
    name: "customerUpload",
    initialState,
    reducers: {
        resetCustomerUpload: () => initialState,
        setCustomerUploadStatus: (
            state,
            action: PayloadAction<CustomerUploadState["status"]>
        ) => {
            state.status = action.payload;
        },
        setCustomerUploadData: (
            state,
            action: PayloadAction<CustomerUploadResponse | null>
        ) => {
            state.data = action.payload;
            state.status = action.payload ? "success" : "error";
        },
        setCustomerUploadError: (
            state,
            action: PayloadAction<string>
        ) => {
            state.error = action.payload;
            state.status = "error";
        },
    },
});

export const {
    resetCustomerUpload,
    setCustomerUploadStatus,
    setCustomerUploadData,
    setCustomerUploadError,
} = customerUploadSlice.actions;

export default customerUploadSlice.reducer;
